import { Route, Switch } from 'react-router-dom';
import React from 'react';
import RequestList from './scenes/List';
import RequestView from './scenes/View';

const RequestRouter = ({ history, match }) => {
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/`}
        render={(props) => <RequestList history={history} match={match} {...props} />}
      />

      <Route
        exact
        path={`${match.url}/:id`}
        render={(props) => <RequestView history={history} match={match} {...props} />}
      />
    </Switch>
  );
};

export default RequestRouter;
